module.exports = __webpack_public_path__ + "img/3.330c5bc7.jpg";